export default "__VITE_ASSET__D4u9D4Vq__"